import { Pipe, PipeTransform } from '@angular/core';
import { separateThousands } from '@nk/utils-lib';

@Pipe({
  name: 'thousandSeparated',
})
export class ThousandSeparatedPipe implements PipeTransform {
  public transform(value: unknown, digits?: number, sep = ' '): string {
    let input: number | null = null;
    if (typeof value === 'number') {
      input = value;
    }
    if (typeof value === 'string') {
      input = +value;
    }
    return separateThousands(input, sep, digits);
  }
}
